import { render, staticRenderFns } from "./Hair6.vue?vue&type=template&id=1f8f9bac&"
import script from "./Hair6.vue?vue&type=script&lang=js&"
export * from "./Hair6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports